import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";


export default function FilePreviewer({ value }) {
  const [show, setShow] = useState(false);

  const handleClick = () => setShow(true);
  const handleClose = () => setShow(false);

  // === Type Checkers ===
  const isImage = (val) => /\.(jpeg|jpg|gif|png|webp|svg)$/i.test(val);
    const isPDF = (val) => /\.pdf$/i.test(val);
    const isURL = (val) =>
    typeof val === "string" && /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w- ./?%&=]*)?$/.test(val);
    const isEmail = (val) =>
    typeof val === "string" &&
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
    const isPhone = (val) =>
    typeof val === "string" && /^(\+91[\s-]?)?[6-9]\d{9}$/.test(val); // Indian numbers
    const isLatLng = (val) => {
    if (typeof val !== "string") return false;
    const parts = val.split(",");
    if (parts.length !== 2) return false;
    const [lat, lng] = parts.map(parseFloat);
    return !isNaN(lat) && !isNaN(lng) && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
    };

  const getType = (val) => {
    if (isImage(val)) return "image";
    if (isPDF(val)) return "pdf";
    if (isURL(val)) return "url";
    if (isEmail(val)) return "email";
    if (isPhone(val)) return "phone";
    if (isLatLng(val)) return "latlng";
    return "text";
  };

  const type = getType(value);

  // === Icon Renderer ===
  const renderIcon = () => {
    const iconStyle = { fontSize: "24px", cursor: "pointer", marginRight: "8px" };
  
    switch (type) {
      case "image":
        return (
          <img
            src={value}
            alt="preview"
            height="40"
            style={{ cursor: "pointer" }}
            onClick={handleClick}
          />
        );
      case "pdf":
        return (
            <i className="bi bi-filetype-pdf" onClick={handleClick}></i>
        );
      case "url":
        return (
          <><i
            className="bi bi-link-45deg"
            onClick={() => window.open(value, "_blank")}
          ></i> {value} </>
        );
      case "email":
        return (
            <>
        {type === "email" && (
        <>
        <a href={`mailto:${value}`} style={{ textDecoration: "none", color: "inherit" }}>
            <i className="bi bi-envelope" style={{ cursor: "pointer" }}></i> {value}
        </a>
        </>
        )}
        </>

        );
      case "phone":
        return (
          <><i
            className="bi bi-telephone-fill"
            onClick={() => window.location.href = `tel:${value}`}
          ></i> {value}</>
        );
      case "latlng":
        return (
            <i className="bi bi-geo-fill" onClick={handleClick} ></i>
        );
      default:
        return <span>{value}</span>;
    }
  };

  // === Modal Content Renderer ===
  const renderContent = () => {
    switch (type) {
      case "image":
        return <img src={value} alt="full view" style={{ maxWidth: "100%" }} />;
      case "pdf":
        const encodedURL = encodeURIComponent(value);
        const googleViewerURL = `https://docs.google.com/gview?url=${encodedURL}&embedded=true`;
        return (
          <iframe
            src={googleViewerURL}
            title="PDF Viewer"
            style={{ width: "100%", height: "500px", border: "none" }}
          />
        );
      case "latlng":
        const [lat, lng] = value.split(",").map((v) => v.trim());
        const mapsLink = `https://www.google.com/maps?q=${lat},${lng}`;
        return (
          <iframe
            src={mapsLink}
            title="Map Location"
            style={{ width: "100%", height: "500px", border: "none" }}
          />
        );
      default:
        return <p style={{ wordBreak: "break-word" }}>{value}</p>;
    }
  };

  return (
    <>
      {renderIcon()}
      <Modal show={type === "image" || type === "pdf" ? show : false} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>File Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>{renderContent()}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}